import React, { Fragment } from "react"

let CodeEight = () => {

    return (
        <Fragment>
            <div className="cell code-cell">
                <div className="ace-github">
                    <div className="ace_static_highlight">
                        <div className="ace_line"><span className="ace_keyword">import</span> <span
                            className="ace_identifier">React</span> <span className="ace_identifier">from</span>
                            <span className="ace_string">"react"</span><span
                                className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><span className="ace_keyword">import</span> <span
                            className="ace_identifier">LabelView</span> <span className="ace_identifier">from</span>
                            <span className="ace_string">"framework/alto/ui/label-view"</span><span
                                className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><span className="ace_keyword">import</span> <span
                            className="ace_identifier">TodoController</span> <span className="ace_identifier">from</span>
                            <span className="ace_string">"application/controllers/todo_controller.js"</span><span
                                className="ace_punctuation ace_operator">;</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_storage ace_type">let</span> <span
                            className="ace_identifier">TodoView</span> <span
                            className="ace_keyword ace_operator">=</span> <span
                            className="ace_paren ace_lparen">(</span><span className="ace_paren ace_rparen">)</span>
                            <span className="ace_keyword ace_operator"> =&gt;</span> <span
                                className="ace_paren ace_lparen">{`{`}</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span><span className="ace_keyword">return</span> <span
                            className="ace_paren ace_lparen">(</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span> <span className="ace_indent-guide">    </span><span
                            className="ace_meta ace_tag ace_punctuation ace_tag-open ace_xml">&lt;</span><span
                            className="ace_meta ace_tag ace_tag-name ace_xml">LabelView</span><span
                            className="ace_text ace_tag-whitespace ace_xml"> </span><span
                            className="ace_entity ace_other ace_attribute-name ace_xml">titleBinding</span><span
                            className="ace_keyword ace_operator ace_attribute-equals ace_xml">=</span><span
                            className="ace_paren ace_quasi ace_start">{`{`}</span><span
                            className="ace_paren ace_lparen">{`{`}</span><span
                            className="ace_identifier">controller</span><span
                            className="ace_punctuation ace_operator">:</span> <span
                            className="ace_identifier">TodoController</span><span
                            className="ace_punctuation ace_operator">,</span> <span
                            className="ace_identifier">key</span><span className="ace_punctuation ace_operator">:</span>
                            <span className="ace_string">'title'</span><span
                                className="ace_paren ace_rparen">}</span><span
                                className="ace_paren ace_quasi ace_end">}</span>}<span
                                className="ace_meta ace_tag ace_punctuation ace_tag-close ace_xml">/&gt;</span>
                        </div>
                        <div className="ace_line"><span className="ace_indent-guide">    </span> <span
                            className="ace_paren ace_rparen">)</span>
                        </div>
                        <div className="ace_line"><br/></div>
                        <div className="ace_line"><span className="ace_paren ace_rparen">}</span><span
                            className="ace_punctuation ace_operator">;</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ace_line"><br/></div>
        </Fragment>
    )

};

export default CodeEight;